import { useEffect, useRef } from "react";
import { animate, useInView } from "framer-motion";

export function CountUp({ value, decimals = 0, delay = 0, duration = 1.8 }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.3 });

  useEffect(() => {
    if (!inView || !ref.current) return undefined;
    const controls = animate(0, value, {
      duration,
      delay,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => {
        if (ref.current) ref.current.textContent = v.toFixed(decimals);
      },
    });
    return () => controls.stop();
  }, [inView, value, decimals, delay, duration]);

  return <span ref={ref}>{(0).toFixed(decimals)}</span>;
}
